import type { PaymentIncidentsTranslations } from "../interfaces/paymentIncidents";

export const paymentIncidentsTranslations: PaymentIncidentsTranslations = {
  provider_fallback: "the provider",
  organization_unknown: "Organization",
  action_cancel: "Cancel",
  action_close: "Close",
  action_back: "Back",
  action_retry: "Retry",
  status_pending_report: "Not reported",
  status_reported: "Reported to {{provider}}",
  status_in_progress: "{{provider}} is on it",
  status_provider_refunded: "{{provider}} refunded",
  status_resolved: "Closed",
  status_dismissed: "Dismissed",
  type_credit_not_applied: "Credit not applied",
  type_credit_not_applied_hint:
    "{{provider}} marks it completed, but the merchant or person never got the money.",
  type_status_not_updated: "Status not updated",
  type_status_not_updated_hint:
    "Still in progress at {{provider}} although it should have finished, like an OTC order that never closes.",
  type_other: "Other issue",
  type_other_hint: "Anything else to check with {{provider}}.",
  resolution_beneficiary_credited: "The beneficiary did get the money",
  resolution_status_updated: "The provider updated the status",
  resolution_other: "Another reason",
  case_strip_label: "Claim progress",
  case_step_pending_report: "Not reported",
  case_step_reported: "Reported",
  case_step_in_progress: "In progress",
  case_step_closed: "Closed",
  case_dismissed: "Dismissed: it was not an incident.",
  case_updated_today: "Updated today.",
  case_quiet_one: "No news for 1 day.",
  case_quiet_other: "No news for {{count}} days.",
  case_stale: "{{count}} days without news: write to {{provider}} again.",
  panel_title: "Provider incident",
  panel_title_with_reference: "Incident {{reference}}",
  panel_empty:
    "If the client says this payment never arrived or got stuck, open an incident to report it to {{provider}} and follow it here.",
  panel_open: "Open incident",
  panel_read_only: "Only staff who can top up wallets can change an incident.",
  panel_opened_by: "opened by {{email}}",
  panel_at_stake: "At stake",
  panel_case_reference: "{{provider}} case number",
  panel_client_refund: "Client refund",
  panel_copy_report: "Copy report for {{provider}}",
  panel_copy_follow_up: "Copy follow-up for {{provider}}",
  panel_record: "Record",
  panel_refund: "Refund the client",
  panel_reading_provider: "Asking {{provider}} to build the report…",
  timeline_title: "Timeline",
  timeline_label: "Incident timeline",
  record_provider_responded: "{{provider}} answered",
  record_provider_refunded: "{{provider}} returned the money",
  record_resolved: "Close the incident",
  record_dismissed: "Dismiss",
  record_note: "Add a note or images",
  record_reopened: "Reopen",
  refund_blocked_payout_not_paid:
    "It cannot be refunded: the payment is not marked as paid. If it failed or was cancelled the money already came back; if it is still in progress it may yet arrive.",
  refund_blocked_incident_closed: "Reopen the incident to refund.",
  refund_blocked_wallet_not_found: "The organization no longer has the wallet the payment left from.",
  refund_blocked_already_refunded: "The client was already refunded.",
  event_opened: "Incident opened",
  event_report_copied: "Report copied for {{provider}}",
  event_report_copied_follow_up: "Follow-up copied for {{provider}}",
  event_provider_responded: "{{provider}} answered",
  event_provider_refunded: "{{provider}} returned the money",
  event_note: "Note",
  event_resolved: "Incident closed",
  event_dismissed: "Incident dismissed",
  event_reopened: "Incident reopened",
  event_client_refunded: "Client refunded",
  event_two_factor: "with 2FA",
  event_two_factor_hint: "Confirmed with the second factor of whoever did it.",
  event_recorded_on: "recorded on {{date}}",
  event_case_reference: "Case number: {{reference}}",
  event_attachments: "Attachments",
  event_attachment_open: "Open {{name}}",
  event_attachment_unavailable: "Unavailable",
  open_title: "Open incident",
  open_description:
    "It is recorded under your email. Then you copy the report for {{provider}} and follow the case here.",
  open_field_type: "Kind of incident",
  open_field_description: "What happened",
  open_field_description_hint:
    "It goes as written into the report for {{provider}}: say what the client or the merchant saw.",
  open_field_description_placeholder:
    "The card terminal showed «Sale not completed» and the merchant got nothing; the client paid again by card.",
  open_validation_description: "Say what happened.",
  open_only: "Open only",
  open_and_report: "Open and copy report",
  open_error: "We could not open the incident. Try again.",
  open_already_exists: "This payment already had an incident: here it is.",
  report_title: "Report for {{provider}}",
  report_description: "Paste it in {{provider}}'s support channel. The copy is on the timeline.",
  report_copy: "Copy",
  report_copy_again: "Copy again",
  report_copied: "Copied",
  report_copied_toast: "Report copied",
  report_copy_error: "It could not be copied. Select the text and copy it by hand.",
  report_auto_copied: "It is already on your clipboard: paste it in {{provider}}'s channel.",
  report_copy_hint: "Use «Copy» and paste it in {{provider}}'s channel.",
  report_text_label: "Report text",
  report_evidence_stored:
    "We could not reach {{provider}} right now: the data comes from what we kept. Check it is complete before sending it.",
  report_evidence_none: "We found no data from {{provider}} for this payment: the report carries only ours.",
  report_two_factor_required: "You need two-step verification on to copy the report.",
  report_two_factor_description: "Copying the report for {{provider}} is recorded with your second factor.",
  event_dialog_title_provider_responded: "{{provider}} answered",
  event_dialog_description_provider_responded:
    "Record what they answered and, if they gave one, the case number.",
  event_dialog_confirm_provider_responded: "Save answer",
  event_note_placeholder_provider_responded:
    "They escalated it to Banrep and ACH; there is no set response time.",
  event_saved_provider_responded: "Answer recorded",
  event_dialog_title_provider_refunded: "{{provider}} returned the money",
  event_dialog_description_provider_refunded: "Mark the incident as refunded by {{provider}}. It closes.",
  event_dialog_confirm_provider_refunded: "Mark refunded",
  event_note_placeholder_provider_refunded: "The refund reached the wallet on …",
  event_saved_provider_refunded: "Refund recorded",
  event_dialog_title_resolved: "Close the incident",
  event_dialog_description_resolved:
    "Close it once nothing is left pending with {{provider}}. It can be reopened.",
  event_dialog_confirm_resolved: "Close incident",
  event_note_placeholder_resolved: "The receiving bank confirmed the credit was applied.",
  event_saved_resolved: "Incident closed",
  event_dialog_title_dismissed: "Dismiss the incident",
  event_dialog_description_dismissed: "For when it was not an incident. It can be reopened.",
  event_dialog_confirm_dismissed: "Dismiss",
  event_note_placeholder_dismissed: "The client pointed at the wrong payment.",
  event_saved_dismissed: "Incident dismissed",
  event_dialog_title_note: "Add a note or images",
  event_dialog_description_note: "A follow-up on the timeline: what you did or what you were told.",
  event_dialog_confirm_note: "Save",
  event_note_placeholder_note: "I wrote to them again on the channel.",
  event_saved_note: "Note saved",
  event_dialog_title_reopened: "Reopen the incident",
  event_dialog_description_reopened: "It goes back to the last open step it reached.",
  event_dialog_confirm_reopened: "Reopen",
  event_note_placeholder_reopened: "The client reported it again.",
  event_saved_reopened: "Incident reopened",
  event_field_resolution: "Why it closes",
  event_field_case_reference: "Case number",
  event_field_case_reference_hint: "The case number {{provider}} gave, if any.",
  event_field_day: "When it happened",
  event_field_day_hint: "If it was another day, set it: the timeline is ordered by that date.",
  event_field_answer: "What they answered",
  event_field_note: "Note",
  event_field_attachments: "Images or documents",
  event_validation_note: "Write a note or attach a file.",
  event_error: "We could not save it. Try again.",
  event_provider_refunded_info:
    "This moves no money in Coloca: the refund lands in the {{provider}} wallet and shows in «Provider balances». If the client was not refunded yet, do it afterwards with «Refund the client».",
  event_provider_refunded_info_refunded:
    "This moves no money in Coloca: the refund lands in the {{provider}} wallet and recovers what Coloca already refunded to the client.",
  event_resolved_refunded_warning:
    "The client was already refunded. If the beneficiary did get the payment, the client has the money twice and it must be recovered by hand.",
  attachments_add: "Attach",
  attachments_hint: "Up to {{max}} images or PDFs of {{size}} MB.",
  attachments_remove: "Remove {{name}}",
  attachments_rejected_too_many: "Only {{max}} files fit.",
  attachments_rejected_too_large: "{{name}} is larger than {{size}} MB.",
  attachments_rejected_unsupported_type: "{{name}} is neither an image nor a PDF.",
  refund_title: "Refund the client",
  refund_title_review: "Review the refund",
  refund_title_done: "Refund credited",
  refund_description: "You give {{organization}} the payment back while {{provider}} sorts it out.",
  refund_description_done: "The client has the money in its wallet and gets the receipt.",
  refund_field_amount: "Amount to refund",
  refund_field_amount_hint:
    "By default, everything the client was charged: {{max}} {{currency}}. You can lower it, not raise it.",
  refund_field_note: "Internal note",
  refund_field_note_hint:
    "Optional. It goes into the internal note and the timeline; the client does not see it.",
  refund_review: "Review refund",
  refund_review_organization: "Organization",
  refund_review_wallet: "Wallet",
  refund_review_wallet_value: "{{currency}} wallet",
  refund_review_charged: "What the client was charged for it",
  refund_review_amount: "Refund",
  refund_review_client_sees:
    "The client sees it in its wallet as «Refund from Coloca Payments», with the refunded payment in the concept, and gets the receipt by email.",
  refund_review_coloca_money:
    "It is Coloca's money until {{provider}} returns the funds. It cannot be undone from here.",
  refund_review_checkbox: "I checked the amount and the organization.",
  refund_confirm: "Refund",
  refund_transit_aria: "Coloca credits {{amount}} {{currency}} to {{name}}",
  refund_transit_from: "Coloca Payments",
  refund_error_already: "This incident already has a refund. We refreshed the view.",
  refund_validation_invalid: "Enter a valid amount.",
  refund_validation_not_positive: "The amount must be greater than zero.",
  refund_validation_precision: "{{currency}} takes up to {{digits}} decimals.",
  refund_validation_exceeds: "It cannot exceed what was charged: {{max}} {{currency}}.",
  refund_two_factor_required: "You need two-step verification on to refund.",
  refund_two_factor_description: "The refund moves Coloca's money: confirm it with your second factor.",
  summary_open: "Open incidents",
  summary_open_meta: "{{pending}} not reported · {{waiting}} awaiting an answer",
  summary_stale: "No news for 7 days or more",
  summary_stale_meta: "Time to write to the provider again",
  summary_at_stake: "At stake",
  summary_advanced: "Advanced by Coloca",
  summary_error: "We could not load the incidents summary.",
  summary_outdated:
    "We could not refresh the summary. These figures are from {{time}} and may be out of date.",
  summary_advanced_meta: "Refunded to clients, not returned by the provider yet",
  filter_open: "Open",
  filter_client_refunded: "Client refunded",
  filter_any: "With an incident",
  filter_none: "No incident",
  filter_pending_report: "Not reported",
  filter_reported: "Reported, no answer yet",
  filter_in_progress: "In progress",
  filter_provider_refunded: "Refunded by the provider",
  filter_resolved: "Closed",
  filter_dismissed: "Dismissed",
  movements_days_quiet_one: "1 day without news",
  movements_days_quiet_other: "{{count}} days without news",
  movements_client_refunded: "Client refunded",
};
